
import { DaButton, DaTextButton } from '@daiso/design-system'
import dayjs from 'dayjs'
import { mapState, mapActions, mapGetters } from 'vuex'
import InfoContainer from '~/components/common/template/InfoContainer.vue'
import IconFlag from '~/components/common/text/IconFlag.vue'
import orMixin from '~/mixin/or/orMixin'
import { commonfunc } from '~/mixin/common'
import SCR_MSG_0021 from '~/pages/ms/msg/SCR_MSG_0021.vue'
import SCR_MBC_0115_01 from '~/pages/mb/mbc/SCR_MBC_0115_01.vue'
import ScrMbc011503 from '~/pages/mb/mbc/SCR_MBC_0115_03.vue'
import ScrMbc011502 from '~/pages/mb/mbc/SCR_MBC_0115_02.vue'
import ScrMbc011702 from '~/pages/mb/mbc/SCR_MBC_0117_02.vue'

export default {
  name: 'DeliveryLocationPanel',
  components: {
    DaTextButton,
    DaButton,
    InfoContainer,
    IconFlag,
    SCR_MSG_0021,
    SCR_MBC_0115_01,
    ScrMbc011503,
    ScrMbc011502,
    ScrMbc011702,
  },
  mixins: [orMixin, commonfunc],
  props: {
    isLogined: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      openPopup: false,
      bassDvya: null, // 기본 배송지
      bassPkupStr: null, // 기본 픽업매장
      pkupStrInfo: null, // 픽업매장 상세 정보
      isLoading: true, // 로딩 상태
      deliveryCutOffTime: null, // 배송 마감 시간 (API에서)
      deliveryArrivalDate: null, // 배송 도착 예정일 (API에서)
      todayDeliveryInfo: null, // 오늘배송 정보
      bulkOrderInfo: null, // 대량주문 정보
      bulkStoreInfo: null, // 대량주문 거점매장 정보
      pkupStTm: '', // 픽업 시작 시간
      tmr: '', // 내일 날짜
      reqShippingDtYn: 'N', // 택배 출발예정일 노출여부
      dlvParmType: '', // 택배 배송예정 타입
      hldyDlvFlagYn: 'N',
      quickStrStrUnable: false, // 오늘배송 서비스 지역 불가
      quickDlvUnable: false, // 오늘배송 이용 불가
      tomorrowHoildayYn: 'N', // 내일 휴무일 여부
      pickupDay: '',
      browserGeolocationGranted: null, // 브라우저 위치정보 동의 상태 (null: 미확인, true: 허용, false: 거부/보류)
      tabButton: [
        {
          id: 'parcel',
          label: '택배배송'
        },
        {
          id: 'pickup',
          label: '매장픽업'
        },
        {
          id: 'today',
          label: '오늘배송'
        },
        {
          id: 'bulk',
          label: '대량주문'
        }
      ],
      isRefreshing: false, // 데이터 갱신 중 여부
      textMap: {
        parcel: {
          loginText: '배송지를 확인해 보세요.',
          title: '배송지',
          noAddress: '배송지를 등록해 주세요.',
          btnText: '배송지 변경',
          btnText2: '배송지 등록',
        },
        pickup: {
          loginText: '픽업 가능 매장을 확인해 보세요.',
          title: '픽업매장',
          noAddress: '대상 픽업매장 없음',
          btnText: '픽업매장 변경',
          btnText2: '픽업매장 등록',
        },
        today: {
          loginText: '오늘배송 가능 여부를 확인해 보세요.',
          title: '배송지',
          noAddress: '배송지를 등록해 주세요.',
          btnText: '배송지 변경',
          btnText2: '배송지 등록',
        },
        bulk: {
          loginText: '대량주문 가능  여부를 확인해 보세요.',
          title: '배송지',
          noAddress: '대상 픽업매장 없음',
          btnText: '배송지 변경',
          btnText2: '배송지 등록',
        },
      }
    }
  },
  computed: {
    ...mapState('delivery', {
      vuexActiveTab: 'activeTab'
    }),
    ...mapGetters('delivery', ['getCurrentDeliveryAddress', 'getCurrentPickupStore']),
    activeTab: {
      get () {
        return this.vuexActiveTab
      },
      set (value) {
        this.updateActiveTab(value)
      }
    },
    currentText () {
      return this.textMap[this.activeTab]
    },
    // 배송지 1차 주소 파싱 (도로명 기준 '~로' or '~길' 앞주소까지)
    deliveryShortAddress () {
      if (!this.bassDvya?.addrBassEaddr) { return '' }
      const address = this.bassDvya.addrBassEaddr
      const words = address.split(' ')
      const targetIndex = words.findIndex(word => word.endsWith('로') || word.endsWith('길'))

      if (targetIndex > 0) {
        return words.slice(0, targetIndex).join(' ')
      }

      return address
    },
    // 팝업 내부용 원본 주소 (말줄임 없음)
    deliveryFullAddress () {
      if (!this.bassDvya?.addrBassEaddr) { return '' }
      return this.bassDvya.addrBassEaddr
    },
    // 픽업매장명 + 9자 말줄임
    pickupStoreName () {
      // return name.length > 9 ? name.substring(0, 9) + '...' : name
      return this.bassPkupStr?.strNm || ''
    },
    // 휴일배송 정보 (store에서 가져오기)
    holidayDeliveryInfo () {
      return this.$store.getters['ds/getHolidayDeliveryInfo']
    },
    // 휴일배송 여부
    isHolidayDelivery () {
      return this.holidayDeliveryInfo?.hldyDlvFlagYn === 'Y' && this.activeTab === 'parcel' && this.hldyDlvFlagYn === 'Y'
    },
    // 도착예정일이 내일인지 확인
    isTomorrow () {
      if (!this.deliveryArrivalDate) { return false }

      const today = new Date()
      const tomorrow = new Date(today)
      tomorrow.setDate(today.getDate() + 1)
      tomorrow.setHours(0, 0, 0, 0) // 시간 초기화

      // deliveryArrivalDate에서 날짜 추출 (MM/DD 형식에서)
      const dateMatch = this.deliveryArrivalDate.match(/(\d{1,2})\/(\d{1,2})/)
      if (!dateMatch) { return false }

      const [, month, day] = dateMatch
      const arrivalDate = new Date(today.getFullYear(), parseInt(month) - 1, parseInt(day))
      arrivalDate.setHours(0, 0, 0, 0) // 시간 초기화

      return arrivalDate.getTime() === tomorrow.getTime()
    },
    // 탭별 배송 예정일 정보
    deliveryInfo () {
      const nowHours = new Date().getHours()

      // 로그인하지 않은 경우 기본 정보 표시
      if (!this.isLogined && this.activeTab === 'bulk') {
        switch (this.activeTab) {
          case 'bulk': {
            // 대량주문: 실제 API에서 받은 배송 예정일 사용
            if (this.bulkOrderInfo) {
              const rawDateStr = this.bulkOrderInfo.dlvParmEdt || this.bulkOrderInfo.dlvParmDt
              if (rawDateStr) {
                const week = ['일', '월', '화', '수', '목', '금', '토']
                let normalized = String(rawDateStr)
                if (/^\d{8}$/.test(normalized)) {
                  normalized = `${normalized.slice(0, 4)}-${normalized.slice(4, 6)}-${normalized.slice(6, 8)}`
                }
                const arrivalDate = new Date(normalized)
                if (!isNaN(arrivalDate.getTime())) {
                  const month = arrivalDate.getMonth() + 1
                  const date = arrivalDate.getDate()
                  const dayOfWeek = week[arrivalDate.getDay()]
                  return {
                    showCutOff: false,
                    cutOffText: '',
                    arrivalText: `${month}/${date}(${dayOfWeek}) 도착예정`
                  }
                }
              }
            }
            return {
              showCutOff: false,
              cutOffText: '',
              arrivalText: '7일 이내 도착예정'
            }
          }
          default:
            return { showCutOff: false, cutOffText: '', arrivalText: '' }
        }
      }

      switch (this.activeTab) {
        case 'parcel': { // 택배배송
          const cutOffTime = this.deliveryCutOffTime || 23
          const arrivalDate = this.deliveryArrivalDate || ''

          // reqShippingDtYn === 'Y' && dlvParmType === '01' && nowHours < Number(cutOffTime) 조건
          if (this.reqShippingDtYn === 'Y' && this.dlvParmType === '01' && nowHours < Number(cutOffTime) && !(this.holidayDeliveryInfo?.hldyDlvFlagYn === 'Y' && this.hldyDlvFlagYn === 'Y')) {
            return {
              showCutOff: true,
              cutOffText: `${cutOffTime}시 전 결제하면`,
              arrivalText: ''
            }
          } else if (this.reqShippingDtYn === 'N') {
            return {
              showCutOff: false,
              cutOffText: '',
              arrivalText: '전국 주 7일 배송 (일부 지역 제외)'
            }
          } else {
            return {
              showCutOff: false,
              cutOffText: '',
              arrivalText: `${arrivalDate} 도착예정`
            }
          }
        }
        case 'today': {
          if (!this.todayDeliveryInfo) {
            return { showCutOff: false, cutOffText: '', arrivalText: '' }
          }

          if (this.isQuickStoreRenewal) {
            return {
              showCutOff: false,
              cutOffText: '',
              arrivalText: `오늘배송 불가, ${this.quickRenewalOrderableDay} 00시부터 주문가능`
            }
          }

          if (this.isQuickTempHoliday) {
            return {
              showCutOff: true,
              cutOffText: '현재 배송지 오늘배송 일시 제한',
              arrivalText: ''
            }
          }

          const { closTm, todayDeliverYn, todayHoildayYn, tomorrowHoildayYn, availQty, nextDay } = this.todayDeliveryInfo
          const week = ['일', '월', '화', '수', '목', '금', '토']
          const nextToday = new Date(this.dateYYYYMMDDFormatterStr(nextDay))
          const month = nextToday.getMonth() + 1
          const date = nextToday.getDate()
          const dayOfWeek = week[new Date(nextToday).getDay()]
          const formattedNextDay = month + '/' + date + '(' + dayOfWeek + ')'

          if (todayDeliverYn === 'Y' && todayHoildayYn === 'N' && ((this.isLogined && availQty > 0) || (!this.isLogined))) {
            return {
              showCutOff: true,
              cutOffText: `${closTm}시 전 결제하면`,
              arrivalText: '',
              flagType: 'arriveToday'
            }
          } else if (todayDeliverYn === 'N' && tomorrowHoildayYn === 'N' && todayHoildayYn === 'N' && ((this.isLogined && availQty > 0) || (!this.isLogined))) {
            return {
              showCutOff: true,
              cutOffText: '오늘배송 마감, 지금 결제하면',
              arrivalText: '',
              flagType: 'arriveTomorrow'
            }
          } else if (this.isLogined && availQty <= 0) {
            return {
              showCutOff: false,
              cutOffText: '',
              arrivalText: `오늘배송 마감, ${formattedNextDay} 00시부터 주문가능`
            }
          } else {
            return {
              showCutOff: false,
              cutOffText: '',
              arrivalText: `오늘배송 휴무, ${formattedNextDay} 00시부터 주문가능`
            }
          }
        }
        case 'bulk': // 대량주문
          // 이용불가 상태인 경우에도 도착예정일 표시
          if (this.bulkOrderInfo) {
          // dlvParmEdt 우선, 없으면 dlvParmDt 사용
            const rawDateStr = this.bulkOrderInfo.dlvParmEdt || this.bulkOrderInfo.dlvParmDt
            if (rawDateStr) {
              const week = ['일', '월', '화', '수', '목', '금', '토']
              // YYYYMMDD 형식 안전 파싱 → YYYY-MM-DD 로 변환
              let normalized = String(rawDateStr)
              if (/^\d{8}$/.test(normalized)) {
                normalized = `${normalized.slice(0, 4)}-${normalized.slice(4, 6)}-${normalized.slice(6, 8)}`
              }
              const arrivalDate = new Date(normalized)
              if (!isNaN(arrivalDate.getTime())) {
                const month = arrivalDate.getMonth() + 1
                const date = arrivalDate.getDate()
                const dayOfWeek = week[arrivalDate.getDay()]
                return {
                  showCutOff: false,
                  cutOffText: '',
                  arrivalText: `${month}/${date}(${dayOfWeek}) 도착예정`
                }
              }
            }
          }

          return {
            showCutOff: false,
            cutOffText: '',
            arrivalText: '7일 이내 도착예정'
          }

        case 'pickup': // 매장픽업
          // 픽업매장 정보가 있는 경우 (로그인한 상태)
          if (this.pkupStrInfo) {
            if (this.isPickupStoreRenewal) {
              return {
                showCutOff: false,
                cutOffText: '',
                arrivalText: `픽업매장 휴무, ${this.pickupRenewalOrderableDay} 00시부터 주문가능`
              }
            }

            const { todayHldyYn } = this.pkupStrInfo
            // 오늘 휴무일인 경우
            if (todayHldyYn === 'Y') {
              const nextPickupDay = this.pickupDay
              return {
                showCutOff: false,
                cutOffText: '',
                arrivalText: `매장픽업 휴무, ${nextPickupDay} 픽업가능`
              }
            }
            // 오늘 capa 마감
            if (this.isLogined && this.pkupStrInfo.strCd && this.pkupStrInfo.availQty <= 0) {
              const nextPickupDay = this.pickupDay
              return {
                showCutOff: false,
                cutOffText: '',
                arrivalText: `매장픽업 마감, ${nextPickupDay} 00시부터 주문가능`
              }
            }

            // 17시 이전인 경우
            if (nowHours < 17) {
              return {
                showCutOff: true,
                cutOffText: '17시 전 결제하면',
                arrivalText: ''
              }
            }

            // 17시 이후이고 내일 가능한 경우
            if (nowHours >= 17 && this.pkupStTm === this.tmr) {
              return {
                showCutOff: true,
                cutOffText: '매장픽업 마감, 지금 결제하면',
                arrivalText: ''
              }
            }

            // 그 외의 경우 (17시 이후이고 내일 휴무)
            const nextPickupDay = this.pickupDay
            return {
              showCutOff: false,
              cutOffText: '',
              arrivalText: `매장픽업 마감, ${nextPickupDay}부터 픽업 가능`
            }
          }
          // 17시 이후인 경우
          return {
            showCutOff: false,
            cutOffText: '',
            arrivalText: '매장픽업 마감, 내일부터 픽업 가능'
          }

        default:
          return { showCutOff: false, cutOffText: '', arrivalText: '' }
      }
    },
    // 픽업매장 거리 포맷팅
    pickupStoreDistance () {
      if (!this.bassPkupStr?.km || this.bassPkupStr.km === 0.0) { return '' }
      const km = this.bassPkupStr.km
      return km >= 1 ? `${km}km` : `${km}m`
    },
    // 대량주문 거점매장 거리 포맷팅
    bulkStoreDistance () {
      // 브라우저 위치정보 동의하지 않은 경우 빈 문자열 반환
      if (this.browserGeolocationGranted === false || this.browserGeolocationGranted === null) {
        return ''
      }
      if (!this.bulkStoreInfo?.km || this.bulkStoreInfo.km === 0.0) { return '' }
      const km = this.bulkStoreInfo.km
      return km >= 1 ? `${km}km` : `${km}m`
    },
    // 픽업매장 이용불가 상태
    isPickupStoreUnavailable () {
      return this.pkupStrInfo?.onlStrYn === 'N' || this.pkupStrInfo?.closeStrYn === 'Y' || this.pkupStrInfo?.bsnSspYn === 'Y' || this.isPickupStoreRenewal
    },
    // 오늘배송 이용불가 상태
    isTodayDeliveryUnavailable () {
      return this.quickStrStrUnable || this.quickDlvUnable || this.isQuickStoreRenewal
    },
    isQuickTempHoliday () {
      return !this.isQuickStoreRenewal && this.todayDeliveryInfo?.quickDlvTmpHlDayYn === 'Y'
    },
    isQuickStoreRenewal () {
      return this.activeTab === 'today' && this.isLogined && this.isRenewalPeriod(this.todayDeliveryInfo)
    },
    isPickupStoreRenewal () {
      return this.activeTab === 'pickup' && this.isLogined && this.isRenewalPeriod(this.pkupStrInfo)
    },
    quickRenewalOrderableDay () {
      return this.getNextOrderableDay(this.todayDeliveryInfo?.renewalEdDt)
    },
    pickupRenewalOrderableDay () {
      return this.getNextOrderableDay(this.pkupStrInfo?.renewalEdDt)
    },
    // 대량배송 이용불가 상태
    isBulkDeliveryUnavailable () {
      // 로그인하지 않은 경우는 이용불가 상태가 아님 (로그인 유도 메시지 표시를 위해)
      if (!this.isLogined) { return false }
      return !this.isNotEmpty(this.bulkStoreInfo?.strCd)
    },
    // 이용불가 상태 체크
    isUnavailableState () {
      return (this.activeTab === 'pickup' && this.isPickupStoreUnavailable) ||
             (this.activeTab === 'today' && this.isTodayDeliveryUnavailable) ||
             (this.activeTab === 'bulk' && this.isBulkDeliveryUnavailable)
    },
    // 폐점/휴점/이용불가 상태 (이용불가 info-container 표시용)
    isClosedOrUnavailable () {
      return (this.activeTab === 'pickup' && this.isPickupStoreUnavailable && this.bassPkupStr?.strCd) ||
             (this.activeTab === 'today' && this.quickStrStrUnable && this.bassDvya?.addrBassEaddr) ||
             (this.activeTab === 'bulk' && this.isBulkDeliveryUnavailable && this.bassDvya?.addrBassEaddr)
    },
    // 일반 정보 표시 여부 (배송지/픽업매장 정보 info-container 표시용)
    shouldShowNormalInfo () {
      // 기존 복잡한 조건
      const baseCondition = (!this.isUnavailableState || this.activeTab === 'bulk') ||
                           !(this.isLogined && !this.bassDvya?.addrBassEaddr && (this.activeTab === 'parcel' || (this.activeTab === 'today' && !this.quickStrStrUnable))) ||
                           !(this.isLogined && this.activeTab === 'pickup' && !this.bassPkupStr?.strCd)

      // 폐점/휴점이 아닐 때만 표시
      return baseCondition && !this.isClosedOrUnavailable
    },
    // 버튼 표시 상태
    buttonDisplayState () {
      if (!this.isLogined) { return 'login' }

      // 배송지와 픽업매장 둘 다 있는 경우
      if (this.bassDvya && this.bassPkupStr) { return 'both' }

      // 배송지만 있는 경우
      if (this.bassDvya) { return 'delivery' }

      // 픽업매장만 있는 경우
      if (this.bassPkupStr) { return 'pickup' }

      return 'none'
    },
    // 탭에 따른 flag-type 설정
    deliveryFlagType () {
      switch (this.activeTab) {
        case 'parcel':
          return 'deliveryToday'
        case 'pickup': {
          if (!this.pkupStrInfo) { return 'pickupToday' }

          const { todayHldyYn } = this.pkupStrInfo
          const now = new Date()
          const nowHours = now.getHours()

          // 오늘 휴무일인 경우
          if (todayHldyYn === 'Y') {
            return null // 휴무일이므로 플래그 없음
          }

          // 17시 이전인 경우
          if (nowHours < 17) {
            return 'pickupToday'
          }

          // 17시 이후이고 내일 가능한 경우
          if (nowHours >= 17 && this.pkupStTm === this.tmr) {
            return 'pickupTomorrow'
          }

          // 그 외의 경우
          return null
        }
        case 'today': {
          if (!this.todayDeliveryInfo) {
            return 'arriveToday'
          }

          if (this.isQuickStoreRenewal || this.isQuickTempHoliday) {
            return null
          }

          const { todayDeliverYn, todayHoildayYn, tomorrowHoildayYn, availQty } = this.todayDeliveryInfo

          if (todayDeliverYn === 'Y' && todayHoildayYn === 'N' && ((this.isLogined && availQty > 0) || (!this.isLogined))) {
            return 'arriveToday'
          } else if (todayDeliverYn === 'N' && tomorrowHoildayYn === 'N' && todayHoildayYn === 'N' && ((this.isLogined && availQty > 0) || (!this.isLogined))) {
            return 'arriveTomorrow'
          } else {
            return null
          }
        }
        case 'bulk':
          return null
        default:
          return 'deliveryToday'
      }
    },
    // 다음 픽업 가능일 계산
    getNextPickupDay () {
      if (!this.pkupStrInfo) { return '내일' }

      const { strHldyDt } = this.pkupStrInfo
      const now = new Date()
      const today = now.toISOString().split('T')[0]
      const tomorrow = new Date(now)
      tomorrow.setDate(tomorrow.getDate() + 1)
      const tomorrowStr = tomorrow.toISOString().split('T')[0]

      // 매장휴일이 있는 경우 다음날 계산
      if (strHldyDt) {
        const holidayDate = new Date(strHldyDt)
        const nextDay = new Date(holidayDate)
        nextDay.setDate(holidayDate.getDate() + 1)

        const week = ['일', '월', '화', '수', '목', '금', '토']
        const month = nextDay.getMonth() + 1
        const date = nextDay.getDate()
        const dayOfWeek = week[nextDay.getDay()]

        return `${month}/${date}(${dayOfWeek})`
      }

      // 일반적인 경우 내일
      const week = ['일', '월', '화', '수', '목', '금', '토']
      const month = tomorrow.getMonth() + 1
      const date = tomorrow.getDate()
      const dayOfWeek = week[tomorrow.getDay()]

      return `${month}/${date}(${dayOfWeek})`
    },
    // 관리 버튼 문구 (등록 여부에 따라 변경/등록 구분)
    managementButtonText () {
      if (!this.isLogined) { return '' }
      const hasDeliveryAddress = !!this.bassDvya?.addrBassEaddr
      const hasPickupStore = !!this.bassPkupStr?.strCd

      if (this.activeTab === 'pickup') {
        return hasPickupStore ? this.currentText.btnText : this.currentText.btnText2
      } else {
        return hasDeliveryAddress ? this.currentText.btnText : this.currentText.btnText2
      }
    },
    // 팝업에 전달할 purchase-value 계산
    getPurchaseValue () {
      switch (this.activeTab) {
        case 'pickup': return '02'
        case 'today': return '05'
        case 'bulk': return '04'
        default: return '01' // parcel
      }
    }
  },
  watch: {
    isLogined: {
      handler (newVal, oldVal) {
        // 로그인 상태가 변경되었을 때만 실행
        if (newVal !== oldVal) {
          if (newVal) {
            // 로그인한 경우 데이터 로드
            this.loadAllData()
          } else {
            // 로그아웃한 경우 데이터 초기화
            this.resetData()
            this.loadDeliveryInfo()
          }
        }
      },
      immediate: false
    },
    buttonDisplayState: {
      handler (newVal) {
        if (newVal === 'pickup') {
          this.activeTab = 'pickup'
        }
      },
      immediate: true
    },
    // Vuex store 배송지 변경 감지
    getCurrentDeliveryAddress (newAddress) {
      if (newAddress && newAddress.bassDvyaYn === 'Y') {
        this.bassDvya = { ...newAddress }
        // 배송지 변경 시 관련 정보도 갱신
        this.loadDeliveryInfo()
        this.loadBulkStore()
      }
    },
    // Vuex store 픽업매장 변경 감지
    getCurrentPickupStore (newStore) {
      if (newStore && newStore.bassPkupStrYn === 'Y') {
        this.bassPkupStr = { ...newStore }
        // 픽업매장 변경 시 관련 정보도 갱신
        this.loadPickupStoreInfo()
      }
    }
  },
  async mounted () {
    // 로그인 여부와 관계없이 배송 정보 로드
    await this.loadDeliveryInfo()
    if (this.isLogined) {
      await this.loadAllData()
    } else {
      await this.loadDeliveryInfo()
      await this.loadPickupStoreInfo()
    }
    this.isLoading = false
  },
  methods: {
    ...mapActions('delivery', ['updateActiveTab']),
    isRenewalPeriod (storeInfo) {
      if (this.isEmpty(storeInfo?.renewalStDt) || this.isEmpty(storeInfo?.renewalEdDt)) {
        return false
      }

      const today = dayjs().format('YYYYMMDD')
      const startDate = dayjs(this.normalizeDate(storeInfo.renewalStDt)).format('YYYYMMDD')
      const endDate = dayjs(this.normalizeDate(storeInfo.renewalEdDt)).format('YYYYMMDD')
      return today >= startDate && today <= endDate
    },
    getNextOrderableDay (date) {
      if (this.isEmpty(date)) {
        return ''
      }

      const nextDay = dayjs(this.normalizeDate(date)).add(1, 'day')
      const week = ['일', '월', '화', '수', '목', '금', '토']
      return `${nextDay.month() + 1}/${nextDay.date()}(${week[nextDay.day()]})`
    },
    normalizeDate (date) {
      const value = String(date || '')
      return /^\d{8}$/.test(value) ? `${value.slice(0, 4)}-${value.slice(4, 6)}-${value.slice(6, 8)}` : value
    },
    showPopup () {
      if (!this.openPopup) {
        this.openPopup = true
      }
    },
    hidePopup (e, refBtnName, refPanelName) {
      const btn = this.$refs[refBtnName]
      const panel = this.$refs[refPanelName]
      if (!btn || !panel) {
        return false
      }
      const to = e.relatedTarget
      if (to && (btn.contains(to) || panel.contains(to))) {
        return
      }
      this.openPopup = false
    },
    async loadAllData () {
      if (this.isRefreshing) { return }
      this.isRefreshing = true

      try {
        // 배송지 정보를 먼저 로드 (대량주문 거점매장 조회에 필요)
        await this.loadDeliveryAddress()

        // 나머지 API들을 병렬로 실행
        const results = await Promise.allSettled([
          this.loadDeliveryInfo(), // 배송 정보 (cutOffTime, arrivalDate)
          this.loadPickupStore(), // 픽업매장 정보
          this.loadBulkStore() // 대량주문 거점매장 정보 (배송지 정보 필요)
        ])

        // 실패한 API가 있는지 확인 (선택사항)
        const failures = results.filter(result => result.status === 'rejected')
        if (failures.length > 0) {
          console.warn('일부 API 호출이 실패했습니다:', failures)
        }
      } catch (error) {
        console.error('데이터 로드 실패:', error)
      } finally {
        this.isRefreshing = false
      }
    },
    resetData () {
      // 로그아웃 시 데이터 초기화
      this.bassDvya = null
      this.bassPkupStr = null
      this.pkupStrInfo = null
      this.deliveryCutOffTime = null
      this.deliveryArrivalDate = null
      this.todayDeliveryInfo = null
      this.bulkOrderInfo = null
      this.bulkStoreInfo = null
      this.pkupStTm = ''
      this.tmr = ''
      this.reqShippingDtYn = 'N'
      this.dlvParmType = ''
      this.quickStrStrUnable = false
      this.quickDlvUnable = false
      this.tomorrowHoildayYn = 'N'
      this.browserGeolocationGranted = null
    },
    async loadDeliveryAddress () {
      if (!this.isLogined) {
        this.bassDvya = null
        return
      }
      try {
        this.bassDvya = await this.selBassDvya()
      } catch (error) {
        console.error('배송지 조회 실패:', error)
        this.bassDvya = null
      }
    },
    async loadPickupStore () {
      if (!this.isLogined) {
        this.bassPkupStr = null
        return
      }
      try {
        this.bassPkupStr = await this.selBassPkupStr()
        await this.loadPickupStoreInfo()
      } catch (error) {
        console.error('픽업매장 조회 실패:', error)
        this.bassPkupStr = null
      }
    },
    async loadPickupStoreInfo () {
      try {
        const strCd = this.bassPkupStr?.strCd || '00001'
        const res = await this.$AxiosBuilder
          .params({ strCd })
          .build()
          .get('/dl/dla-api/selStrInfo')
        this.pkupStrInfo = res.data?.data

        // 픽업 가능일 설정
        if (this.pkupStrInfo.strCd && this.pkupStrInfo.availQty <= 0) {
          const hldySet = new Set(this.pkupStrInfo.strHldyDtList)
          const week = ['일', '월', '화', '수', '목', '금', '토']
          let checkDate = dayjs().add(1, 'day')
          for (let i = 0; i < 30; i++) {
            if (!hldySet.has(checkDate.format('YYYYMMDD'))) {
              this.pickupDay = `${checkDate.month() + 1}/${checkDate.date()}(${week[checkDate.day()]})`
              break
            }
            checkDate = checkDate.add(1, 'day')
          }
        } else if (this.pkupStrInfo?.pkupStTm) {
          const pickupDate = this.formatDateWithDay(this.pkupStrInfo.pkupStTm)
          this.pkupStTm = pickupDate.formatted
          this.pickupDay = pickupDate.display
        }

        // 내일 날짜 설정
        const tomorrow = new Date()
        tomorrow.setDate(tomorrow.getDate() + 1)
        this.tmr = tomorrow.toISOString().split('T')[0]

        // 거리 정보 가져오기
        await this.loadPickupStoreDistance()
      } catch (error) {
        console.error('픽업매장 상세 정보 조회 실패:', error)
        this.pkupStrInfo = null
      }
    },
    async loadPickupStoreDistance () {
      try {
        // 위치 기반 서비스 이용 약관 확인
        const geoRes = await this.$AxiosBuilder
          .data({
            mbMngNo: this.getMbMngNo(),
            mbEid: this.$store.getters['session/getMbEid'],
            lcInfoGetSeCd: this.checkMobile()
          })
          .build()
          .post('/ms/msg/selGeolocationAgrYn')

        if (geoRes.data?.data?.geolocationAgrYn === 'Y') {
          // 위치 정보 가져오기 (Promise로 감싸기)
          const geoData = await new Promise((resolve) => {
            const data = {
              strLttd: 0.0,
              strLitd: 0.0,
              flag: false,
              geolocationAgrYn: 'N'
            }

            if ('geolocation' in navigator) {
              navigator.geolocation.getCurrentPosition((position) => {
                data.strLttd = position.coords.latitude
                data.strLitd = position.coords.longitude
                data.flag = true
                data.geolocationAgrYn = 'Y'
                console.log('위치정보 사용 가능')
                resolve(data)
              }, (e) => {
                // 아성다이소 좌표로 셋팅
                data.strLttd = 37.486592
                data.strLitd = 127.0480896
                data.flag = false
                data.geolocationAgrYn = 'N'
                console.log('위치정보 사용 불가능')
                resolve(data)
              })
            } else {
              // 아성다이소 좌표로 셋팅
              data.strLttd = 37.486592
              data.strLitd = 127.0480896
              data.flag = false
              data.geolocationAgrYn = 'N'
              console.log('위치정보 사용 불가능')
              resolve(data)
            }
          })

          // 위치 정보가 있는 경우에만 거리 계산
          if (geoData.flag && geoData.strLttd && geoData.strLitd) {
            const selStoreForm = {
              inclusiveStrCd: this.bassPkupStr.strCd,
              keyword: '',
              curLitd: geoData.strLitd,
              curLttd: geoData.strLttd
            }

            const res = await this.$AxiosBuilder
              .data(selStoreForm)
              .build()
              .post('/ms/msg/selStr')

            if (res.data?.data?.[0]?.km) {
              this.$set(this.bassPkupStr, 'km', res.data.data[0].km)
            }
          }
        }
      } catch (error) {
        console.error('픽업매장 거리 정보 조회 실패:', error)
      }
    },
    openStoreInfo () {
      if (this.$refs.storeInfoPopup && this.bassPkupStr?.strCd) {
        this.$refs.storeInfoPopup.strCd = this.bassPkupStr.strCd
        this.$refs.storeInfoPopup.outerVisible = true
      }
    },
    openBulkStoreInfo () {
      if (this.$refs.storeInfoPopup && this.bulkStoreInfo?.strCd) {
        this.$refs.storeInfoPopup.strCd = this.bulkStoreInfo.strCd
        this.$refs.storeInfoPopup.outerVisible = true
      }
    },
    async loadDeliveryInfo () {
      try {
        // 상품상세와 같은 기준 시각으로 조회한다.
        const dtStr = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS')

        const dlvParamList = [
          {
            mbMngNo: this.getMbMngNo(),
            orTyCd: '01', // 택배배송
            disDlvParmYn: 'Y',
            dtStr
          },
          {
            mbMngNo: this.getMbMngNo(),
            orTyCd: '04', // 오늘배송
            disDlvParmYn: 'Y',
            dtStr
          },
          {
            mbMngNo: this.getMbMngNo(),
            orTyCd: '02', // 대량주문
            disDlvParmYn: 'Y',
            dtStr
          }
        ]

        const res = await this.$AxiosBuilder
          .data({
            dlvSoList: dlvParamList,
            mbMngNo: this.getMbMngNo(),
            dtStr
          })
          .build()
          .post('/common/dla-api/selDlvParmDtAll')

        if (res.data) {
          // 택배배송 정보 처리
          if (res.data['01']) {
            const result = res.data['01']
            if (result) {
              this.deliveryCutOffTime = result.cutOffTime
              this.reqShippingDtYn = result.reqShippingDtYn
              this.dlvParmType = result.dlvParmType
              this.hldyDlvFlagYn = result.hldyDlvFlagYn

              // 도착 예정일 포맷팅
              if (result.dlvParmDt) {
                const week = ['일', '월', '화', '수', '목', '금', '토']
                const arrivalDate = new Date(result.dlvParmDt)
                const month = arrivalDate.getMonth() + 1
                const date = arrivalDate.getDate()
                const dayOfWeek = week[arrivalDate.getDay()]

                // 내일 날짜와 비교
                const tomorrow = new Date()
                tomorrow.setDate(tomorrow.getDate() + 1)
                tomorrow.setHours(0, 0, 0, 0) // 시간 초기화

                const arrivalDateOnly = new Date(arrivalDate)
                arrivalDateOnly.setHours(0, 0, 0, 0) // 시간 초기화

                if (arrivalDateOnly.getTime() === tomorrow.getTime()) {
                  this.deliveryArrivalDate = `내일 ${month}/${date}(${dayOfWeek})`
                } else {
                  this.deliveryArrivalDate = `${month}/${date}(${dayOfWeek})`
                }
              }
            }
          }

          // 오늘배송 정보 처리
          if (res.data['04']) {
            const result = res.data['04']
            if (result) {
              this.todayDeliveryInfo = {
                closTm: result.closTm,
                todayDeliverYn: result.todayDeliverYn,
                todayHoildayYn: result.todayHoildayYn,
                tomorrowHoildayYn: result.tomorrowHoildayYn,
                maxWeight: result.maxWeight,
                availQty: 0,
                nextDay: result.nextDay,
                quickDlvTmpHlDayYn: 'N',
                renewalStDt: '',
                renewalEdDt: ''
              }
              this.tomorrowHoildayYn = result.tomorrowHoildayYn || 'N'

              // 오늘배송 이용가능 여부는 별도 로직으로 처리
              await this.checkTodayDeliveryAvailability()
            }
          }

          // 대량주문 정보 처리
          if (res.data['02']) {
            const result = res.data['02']
            if (result) {
              this.bulkOrderInfo = {
                dlvParmEdt: result.dlvParmEdt,
                dlvParmDt: result.dlvParmDt
              }
            }
          }
        }
      } catch (error) {
        console.error('배송 정보 조회 실패:', error)
        // 기본값 설정
        this.deliveryCutOffTime = 23
        this.deliveryArrivalDate = ''
      }
    },
    async loadBulkStore () {
      if (!this.isLogined) {
        this.bulkStoreInfo = null
        return
      }

      try {
        // 배송지가 없는 경우 종료 및 초기화
        if (!this.bassDvya?.addrZip) {
          this.bulkStoreInfo = null
          return
        }

        // 대량주문 거점매장 정보 조회
        // 1. 먼저 거점매장 정보 조회 (zip 기반)
        const posiStr = await this.selPosiStrInfo(this.bassDvya.addrZip, false)

        if (!posiStr?.strCd) {
          this.bulkStoreInfo = null
          return
        }

        // 2. 위치 기반 서비스 이용 약관 확인
        const geoRes = await this.$AxiosBuilder
          .data({
            mbMngNo: this.getMbMngNo(),
            mbEid: this.$store.getters['session/getMbEid'],
            lcInfoGetSeCd: this.checkMobile()
          })
          .build()
          .post('/ms/msg/selGeolocationAgrYn')

        if (geoRes.data?.data?.geolocationAgrYn === 'Y') {
          // 위치 정보 가져오기
          const geoData = await new Promise((resolve) => {
            const data = {
              strLttd: 0.0,
              strLitd: 0.0,
              flag: false,
              geolocationAgrYn: 'N'
            }

            if ('geolocation' in navigator) {
              navigator.geolocation.getCurrentPosition((position) => {
                data.strLttd = position.coords.latitude
                data.strLitd = position.coords.longitude
                data.flag = true
                data.geolocationAgrYn = 'Y'
                this.browserGeolocationGranted = true // 브라우저 위치정보 허용됨
                resolve(data)
              }, (e) => {
                data.strLttd = 0.0
                data.strLitd = 0.0
                data.flag = false
                data.geolocationAgrYn = 'N'
                this.browserGeolocationGranted = false // 브라우저 위치정보 거부/보류됨
                resolve(data)
              })
            } else {
              data.strLttd = 0.0
              data.strLitd = 0.0
              data.flag = false
              data.geolocationAgrYn = 'N'
              this.browserGeolocationGranted = false // 브라우저 위치정보 지원 안함
              resolve(data)
            }
          })

          // 3. 거점매장 상세 정보 조회 (strCd 기반)
          const selStoreForm = {
            inclusiveStrCd: posiStr.strCd, // 거점매장 코드 사용
            keyword: '',
            curLitd: geoData.strLitd ?? '',
            curLttd: geoData.strLttd ?? ''
          }
          const res = await this.$AxiosBuilder
            .data(selStoreForm)
            .build()
            .post('/ms/msg/selStr')

          if (res.data?.data?.[0]) {
            this.bulkStoreInfo = res.data.data[0]
          }
        }
      } catch (error) {
        console.error('대량주문 거점매장 조회 실패:', error)
        this.bulkStoreInfo = null
      }
    },
    // 배송지/픽업매장 관리 팝업 열기
    openDeliveryManagement () {
      if (this.$refs.deliveryManagementPopup) {
        this.$refs.deliveryManagementPopup.outerVisible = true
      }
    },
    // 변경 팝업 열기 (탭에 따라 다른 팝업)
    openChangePopup () {
      if (this.activeTab === 'pickup') {
        this.openPickupLayer()
      } else {
        this.openLayer()
      }
    },
    openLayer () {
      this.$refs.dvyaChgPpup.outerVisible = true
    },
    openPickupLayer () {
      this.$refs.pickPpup.outerVisible = true
    },
    changePkupStr (data) {
      console.log('픽업매장 변경:', data)
      const pkupStr = {
        strNknmNm: data?.strNknmNm,
        strCd: data?.strCd,
        strNm: data?.strNm,
        bassPkupStrYn: data?.bassPkupStrYn,
        strZip: data?.strZip,
        strAddr: data?.strAddr,
        strDtlAddr: data?.strDtlAddr,
        strTno: data?.strTno,
        opngTime: data?.opngTime,
        clsngTime: data?.clsngTime,
        useYn: data?.useYn,
        pkupYn: data?.pkupYn
      }
      this.onDeliveryDataChanged({ pickupChanged: true, data: pkupStr })
    },
    closeDvyaChgPpup (form) {
      if (form && form.bassDvyaYn === 'Y') {
        this.onDeliveryDataChanged({ deliveryChanged: true })
      }
    },
    // 배송지/픽업매장 데이터 변경 시 호출
    async onDeliveryDataChanged (data) {
      console.log('배송지/픽업매장 데이터 변경됨:', data)
      // 변경 사항이 있는 경우 전체 데이터 다시 로드
      await this.loadAllData()
    },
    // 배송지/픽업매장 관리 팝업 닫힐 때 호출
    onDeliveryManagementClosed () {
      console.log('배송지/픽업매장 관리 팝업 닫힘')
      // 팝업이 닫힐 때도 데이터 갱신
      this.loadAllData()
    },
    // 오늘배송 이용가능 여부 확인 (SCR_PDR_000C_2.vue 로직 참고)
    async checkTodayDeliveryAvailability () {
      try {
        if (this.isLogined && this.bassDvya && this.bassDvya.addrZip) {
          // 배송지가 있는 경우 거점매장 조회
          const posiStr = await this.selectPosiQuickStrInfo(this.bassDvya.addrZip, false)
          console.log('DeliveryLocationPanel - posiStr:', posiStr)
          console.log('DeliveryLocationPanel - isLogined:', this.isLogined)

          if (this.isLogined && !posiStr) {
            // 거점매장이 없는 경우
            this.quickStrStrUnable = true
            this.quickDlvUnable = false
            this.todayDeliveryInfo.quickDlvTmpHlDayYn = 'N'
            this.todayDeliveryInfo.renewalStDt = ''
            this.todayDeliveryInfo.renewalEdDt = ''
            this.todayDeliveryInfo.availQty = 1
          } else if (posiStr?.quickDlvTmpHlDayYn === 'Y') {
            // 오늘배송권역매장이나 임시휴무인 경우
            this.quickStrStrUnable = false
            this.quickDlvUnable = true
            this.todayDeliveryInfo.quickDlvTmpHlDayYn = posiStr.quickDlvTmpHlDayYn
            this.todayDeliveryInfo.renewalStDt = posiStr.renewalStDt
            this.todayDeliveryInfo.renewalEdDt = posiStr.renewalEdDt
            this.todayDeliveryInfo.availQty = 1
          } else if (posiStr && this.todayDeliveryInfo.todayHoildayYn === 'N' &&
                     (this.todayDeliveryInfo.todayDeliverYn === 'Y' || this.tomorrowHoildayYn === 'N')) {
            // 오늘배송 가능한 경우
            this.quickStrStrUnable = false
            this.quickDlvUnable = false
            this.todayDeliveryInfo.quickDlvTmpHlDayYn = 'N'
            this.todayDeliveryInfo.renewalStDt = posiStr.renewalStDt
            this.todayDeliveryInfo.renewalEdDt = posiStr.renewalEdDt
            this.todayDeliveryInfo.availQty = posiStr.availQty
          } else {
            // 그 외의 경우 (오늘배송 불가능하지만 서비스 지역은 가능)
            this.quickStrStrUnable = false
            this.quickDlvUnable = true
            this.todayDeliveryInfo.quickDlvTmpHlDayYn = 'N'
            this.todayDeliveryInfo.renewalStDt = posiStr?.renewalStDt
            this.todayDeliveryInfo.renewalEdDt = posiStr?.renewalEdDt
            this.todayDeliveryInfo.availQty = posiStr?.availQty ?? 0
          }
        } else {
          // 배송지가 없거나 비로그인인 경우
          this.quickStrStrUnable = false
          this.quickDlvUnable = this.isLogined
          if (this.todayDeliveryInfo) {
            this.todayDeliveryInfo.quickDlvTmpHlDayYn = 'N'
            this.todayDeliveryInfo.renewalStDt = ''
            this.todayDeliveryInfo.renewalEdDt = ''
            this.todayDeliveryInfo.availQty = 1
          }
        }
      } catch (error) {
        console.error('오늘배송 이용가능 여부 확인 실패:', error)
        this.quickStrStrUnable = false
        this.quickDlvUnable = false
        if (this.todayDeliveryInfo) {
          this.todayDeliveryInfo.quickDlvTmpHlDayYn = 'N'
          this.todayDeliveryInfo.renewalStDt = ''
          this.todayDeliveryInfo.renewalEdDt = ''
        }
      }
    }
  }
}
